import { InteractionType, InteractionTypes } from "game-common/mechanics/entity_mechanics"
import { Graphics } from "pixi.js"
import { EntityInteractionCallback } from "../../../../client_game_logic"
import { BaseRenderable } from "./base_renderable"
import { BasicSprite } from "./basic_sprite"

class InteractionWidget extends Graphics {
    interaction: InteractionType
    constructor(interaction: InteractionType) {
        super()
        this.interaction = interaction
    }
}

export class Interactions {
    interactionWidgets: InteractionWidget[] = []
    interactions: InteractionType[] = []
    interactionWidgetsContainer: Graphics
    interactionCallback: EntityInteractionCallback

    posY: number

    constructor(x: number, y: number, parentArea: BaseRenderable, interactionCallback: EntityInteractionCallback) {
        this.interactionWidgetsContainer = new Graphics()
        this.posY = y
        this.interactionWidgetsContainer.x = x
        this.interactionWidgetsContainer.y = y
        this.interactionWidgetsContainer.visible = false
        this.interactionCallback = interactionCallback

        InteractionTypes.map((interactionType, i) => {
            let iconName = ""
            // Most action icons are drawn from ~28x26 source art, which lands right inside the 20px
            // widget circle at half scale. An icon cut from smaller art needs its own scale to carry
            // the same visual weight — see "food" below.
            let iconScale = 0.5
            switch (interactionType) {
                case "chat": {
                    iconName = "action-chat.png"
                    break
                }
                case "take": {
                    iconName = "action-take.png"
                    break
                }
                case "burn": {
                    iconName = "action-burn.png"
                    break
                }
                case "inventory": {
                    iconName = "inventory.png"
                    break
                }
                case "crown": {
                    iconName = "action-crown.png"
                    break
                }
                case "button": {
                    iconName = "action-take.png"
                    break
                }
                case "command": {
                    // The defender/forager command hover icon uses the chat (speech-bubble) frame
                    // until a dedicated command icon is added to humanoid.json.
                    iconName = "action-chat.png"
                    break
                }
                case "food": {
                    // "Give me a meal" (the ember fire-recruit). Reuses the drumstick item art, which
                    // is only 19x12 — scaled up so it reads as big as the other action icons.
                    iconName = "drumstick-brown.png"
                    iconScale = 0.85
                    break
                }
            }
            const widget = new InteractionWidget(interactionType)

            widget.beginFill(0x000000)
            widget.alpha = 1
            widget.drawCircle(0, 0, 10)
            widget.endFill()
            widget.visible = false
            widget.interactive = true
            widget.zIndex = 10000
            const handler = () => {
                // alert(interactionType)
                this.interactionCallback("_", interactionType)
                // Do NOT clear the "icons" hover region here. The pointer is still over this
                // icon, so world mouse actions must stay disabled — otherwise clicking again
                // (e.g. open then close a chest) would fall through to a world attack, since
                // that click comes from a document-level mousedown. The overlay is hidden and
                // world actions re-enabled by the real mouseout when the pointer leaves.
            }
            widget.on("click", handler)
            widget.on("tap", handler)
            widget.on("mouseover", () => {
                parentArea.onIconHoverChange?.(true)
            })
            widget.on("mouseout", () => {
                parentArea.onIconHoverChange?.(false)
            })
            widget.addChild(
                new BasicSprite({
                    name: iconName,
                    scale: iconScale,
                    color: 0xffffff,
                }),
            )
            widget.cursor = "pointer"
            this.interactionWidgetsContainer.addChild(widget)
            this.interactionWidgets.push(widget)
        })
    }

    updateInteractions(interactions: InteractionType[]): void {
        let pos = -1
        this.interactionWidgets.forEach((widget, i) => {
            if (interactions.includes(widget.interaction)) {
                pos++
                widget.y = this.posY + 25 + 22 * pos
                widget.visible = true
            } else {
                widget.visible = false
            }
        })
    }
}
